// type = save | delete

function showModal(text = "Are You Sure?", type = "save", secondary_text = "",special_text = "") {
  const h = this.$createElement;

  const messageVNode = h("div", [
    special_text
      ? h(
          "div",
          { style: { fontWeight: "bold", color: "#FF0000" } },
          special_text
        )
      : null,
    secondary_text
      ? h(
          "div",
          { style: { fontSize: "0.875rem", color: "#b2b1b9" } },
          secondary_text
        )
      : null,
    h("div", text),
  ]);

  return this.$bvModal
    .msgBoxConfirm(messageVNode, {
      title: "Confirmation",
      size: "sm",
      buttonSize: "sm",
      okVariant: type == "save" ? "success" : "danger",
      cancelVariant: type == "save" ? "outline-success" : "outline-danger",
      okTitle: "YES",
      cancelTitle: "NO",
      footerClass: "p-2",
      hideHeaderClose: true,
      centered: true,
    })
    .then((value) => {
      return value;
    })
    .catch((err) => {
      console.log("error");
      return false;
    });
}

export default showModal;
